import React, { Component } from 'react';
import { connect } from "react-redux";
import { postLogin } from '../../Core/User/Login/action';
import LoginConfirm from '../../Components/login/LoginConfirm';
import LoginComponent from '../../Components/login/Login';
import styles from "../../Assets/Styles/Components/login/Login.module.css";

class Login extends Component {
	constructor(props) {
		super(props);
		this.state = {
			phone: '',
			password: '',
			isConfirm: false,
		};
	}

	onPhoneChange = (phone) => {
		this.setState({ phone });
	}

	onPasswordChange = (password) => {
		// TODO: check password input
		this.setState({ password });
	}

	onBackPress = () => {
		this.setState({
			isConfirm: false,
			phone: '',
			password: '',
		});
		this.props.postLogin();
	}

	callConfirm = () => {
		//    TODO: sending a voice call for verification
	}

	onLogin = () => {
		// TODO: call async action for login
		const { phone } = this.state;
		if (phone !== '') {
			this.setState({ isConfirm: true });
		}
	}

	render() {
		const { phone, password, isConfirm } = this.state;
		return (
			<section className={styles.container}>
				{isConfirm
					? (
						<LoginConfirm
							phone={phone}
							onChange={this.onPasswordChange}
							password={password}
							back={this.onBackPress}
							callConfirm={this.callConfirm}
						/>
					)
					: (
						<LoginComponent
							onChange={this.onPhoneChange}
							phone={phone}
							onLogin={this.onLogin}
						/>
					)}
			</section>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		confirm: state.confirm,
		call: state.call,
	};
};
export default connect(mapStateToProps, { postLogin })(Login);
